import { render, staticRenderFns } from "./FormOthers.vue?vue&type=template&id=d29f1072&scoped=true&"
import script from "./FormOthers.vue?vue&type=script&lang=js&"
export * from "./FormOthers.vue?vue&type=script&lang=js&"
import style0 from "./FormOthers.vue?vue&type=style&index=0&id=d29f1072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29f1072",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
